import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import smoothscroll from 'smoothscroll-polyfill';

import ScrollSwiper from './ScrollSwiper.component';

/** @namespace Bodypwa/Component/ScrollSwiper/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    isMobile: state.ConfigReducer.device.isMobile
});

/** @namespace Bodypwa/Component/ScrollSwiper/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({
});
/** @namespace Bodypwa/Component/ScrollSwiper/Container */
export class ScrollSwiperContainer extends PureComponent {
    static propTypes = {
        children: PropTypes.node.isRequired,
        isAutoScroll: PropTypes.bool,
        isMobile: PropTypes.bool.isRequired
    };

    static defaultProps = {
        isAutoScroll: false
    };

    componentDidMount() {
        smoothscroll.polyfill();
    }

    containerProps() {
        const { children, isAutoScroll, isMobile } = this.props;

        return {
            children,
            isAutoScroll,
            isMobile
        };
    }

    render() {
        return (
            <ScrollSwiper
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ScrollSwiperContainer);
